<template>
    <div class="xxpl">
        <div class="banner">
            <img class="banner_img" src="../../static/img/xxpl_banner.png" alt="">
        </div>
        <div class="content">
            <div class="content_pl">
                <div class="gsList" :class="{ active_nav2 : nav }">
                    <p v-for="(item,i) in gsList" :key="i" @click="active = i" :class="{ active: active === i }">
                        <span>{{item.name}}</span>
                    </p>
                </div>
                <div class="gsjs">
                    <div class="nr" v-for="(item,i) in fzContent" :key="i" v-if="active === 0">
                        <h2>{{item.gsName}}</h2>
                        <p class="fwjs f500">{{item.bt}}</p>
                        <p class="bt">{{item.bt1}}</p>
                        <p class="sj_text">{{item.btnr_1}}</p>
                        <p class="sj_text">{{item.btnr_2}}</p>
                        <p class="sj_text">{{item.btnr_3}}</p>
                        <p class="sj_text">{{item.btnr_4}}</p>
                        <p class="sj_text">{{item.btnr_5}}</p>
                        <p class="fwjs f500">{{item.bt2}}</p>
                        <table width="833" border="1" cellspacing="0" cellpadding="0">
                            <tr>
                                <td>机构中文全称</td>
                                <td> 天津协和万邦保险经纪有限公司</td>
                                <td>机构中文简称</td>
                                <td>协和万邦</td>
                            </tr>
                            <tr>
                                <td>机构英文全称</td>
                                <td>无</td>
                                <td>机构英文简称</td>
                                <td>无</td>
                            </tr>
                            <tr>
                                <td>注册资本（万元</td>
                                <td>5000万元</td>
                                <td>设立时间（年/月/日）</td>
                                <td>2008/10/22</td>
                            </tr>
                            <tr>
                                <td scope="col">机构具体地址</td>
                                <td colspan="3" scope="col">天津市武清开发区福源道北侧</td>
                            </tr>
                            <tr>
                                <td colspan="2">经营互联网保险业务的网站名称</td>
                                <td colspan="2">无</td>
                            </tr>
                            <tr>
                                <td colspan="2">经营互联网保险业务的网站地址</td>
                                <td colspan="2">无</td>
                            </tr>
                            <tr>
                                <td colspan="2">经营互联网保险业务的APP名称</td>
                                <td colspan="2">停有钱 小二保险</td>
                            </tr>
                            <tr>
                                <td colspan="2">经营互联网保险业务的微信公众号名称</td>
                                <td colspan="2">无</td>
                            </tr>
                            <tr>
                                <td colspan="2">客户服务及消费者投诉电话</td>
                                <td colspan="2">400-665-0265</td>
                            </tr>
                            <tr>
                                <td colspan="2">公司信息披露网站地址</td>
                                <td colspan="2">http://www.feizhubaoxian.com/</td>
                            </tr>
                            <tr>
                                <td>公司管理员姓名</td>
                                <td>杨晓强</td>
                                <td>公司管理员座机（加区号）</td>
                                <td>010-68973668</td>
                            </tr>
                            <tr>
                                <td>公司管理员手机</td>
                                <td>13810174838</td>
                                <td>公司管理员微信号</td>
                                <td>Xuelang_0521</td>
                            </tr>
                            <tr>
                                <td>公司管理员部门</td>
                                <td>商务部</td>
                                <td>公司管理员职务</td>
                                <td> </td>
                            </tr>
                            <tr>
                                <td>公司管理员邮箱</td>
                                <td>13810174838@163.com</td>
                                <td>公司负责领导 （直接责任人）

                                </td>
                                <td>梁宗伟</td>
                            </tr>
                            <tr>
                                <td>公司负责领导座机</td>
                                <td>010-68973668</td>
                                <td>公司负责领导手机</td>
                                <td>180001311298</td>
                            </tr>
                        </table>
                        <p class="fwjs f500">{{item.bt3}}</p>
                        <table width="833" border="1" cellspacing="0" cellpadding="0">
                            <tr>
                                <td>实际销售名称</td>
                                <td>备案产品名称</td>
                                <td>备案编号/批复文号</td>
                                <td>承保保险公司名称</td>
                            </tr>
                            <tr>
                                <td>机动车综合商业保险</td>
                                <td>机动车综合商业保险条款</td>
                                <td>机动车综合商业保险条款</td>
                                <td>安盛天平财产保险股份有限公司</td>
                            </tr>
                            <tr>
                                <td>机动车交通事故责任强制保险</td>
                                <td>机动车交通事故责任强制保险条款</td>
                                <td>中保协条款[2006]1号</td>
                                <td>安盛天平财产保险股份有限公司</td>
                            </tr>
                            <tr>
                                <td>机动车综合商业保险</td>
                                <td>机动车综合商业保险条款</td>
                                <td>保监许可〔2015〕416号</td>
                                <td>合众财产保险股份有限公司</td>
                            </tr>
                            <tr>
                                <td>机动车交通事故责任强制保险</td>
                                <td>机动车交通事故责任强制保险条款</td>
                                <td>中保协条款[2006]1号</td>
                                <td>合众财产保险股份有限公司</td>
                            </tr>
                            <tr>
                                <td>合众综合交通工具意外伤害保险（2013修订）</td>
                                <td>合众综合交通工具意外伤害保险（2013修订）</td>
                                <td>合保发（2013）216号</td>
                                <td>合众人寿保险股份有限公司</td>
                            </tr>
                            <tr>
                                <td>合众附加综合交通工具意外伤害医疗保险(2013修订)</td>
                                <td>合众附加综合交通工具意外伤害医疗保险(2013修订)</td>
                                <td>合保发（2011）70号</td>
                                <td>合众人寿保险股份有限公司</td>
                            </tr>
                        </table>
                    </div>
                    <!-- 中国人民财产保险股份有限公司 -->
                    <div class="nr" v-for="(item,i) in rmContent" :key="i" v-if="active === 1">
                        <h2>{{item.gsName}}</h2>
                        <p class="fwjs">{{item.bt}}</p>
                        <p class="bt">{{item.bt1}}</p>
                        <p class="sj_text">{{item.btnr_1}}</p>
                        <p class="sj_text">{{item.btnr_2}}</p>
                        <p class="bt">{{item.bt2}}</p>
                        <p>{{item.btnr_3}}</p>
                        <p class="bt">{{item.bt3}}</p>
                        <p>{{item.btnr_4}}</p>
                        <p class="bt">{{item.bt4}}</p>
                        <p class="bt">{{item.bt5}}</p>
                        <p class="bt">{{item.bt6}}</p>
                        <p class="fwjs">{{item.bt7}}</p>
                        <p class="bt">{{item.bt8}}</p>
                        <p>{{item.btnr_5}}</p>
                        <p>{{item.btnr_6}}</p>
                        <p> {{item.btnr_7}}</p>
                        <P> {{item.btnr_8}}</p>
                        <p class="bt">{{item.bt9}}</p>
                        <p>{{item.btnr_9}}</p>
                        <p>{{item.btnr_10}}</p>
                        <p>{{item.btnr_11}}</p>
                        <p class="bt">{{item.bt10}}</p>
                        <p> {{item.btnr_12}} </p>
                        <p class="fwjs">{{item.bt11}}</p>
                        <p>{{item.btnr_13}}</p>
                        <p class="fwjs">{{item.bt12}}</p>
                        <p>{{item.btnr_14}}</p>
                        <p>{{item.btnr_15}}</p>
                        <p>{{item.btnr_16}}</p>
                        <p>{{item.btnr_17}}</p>
                        <p>{{item.btnr_18}}</p>
                    </div>
                    <!-- 中华联合保险控股股份有限公司 -->
                    <div class="nr" v-for="(item,i) in zhContent" :key="i" v-if="active === 2">
                        <h2>{{item.gsName}}</h2>
                        <p class="fwjs">{{item.bt}}</p>
                        <p class="bt">{{item.bt1}}</p>
                        <p>{{item.btnr_1}}</p>
                        <p class="bt">{{item.bt2}}</p>
                        <p>{{item.btnr_2}}</p>
                        <p class="bt">{{item.bt3}}</p>
                        <p>{{item.btnr_3}}</p>
                        <p class="bt">{{item.bt4}}</p>
                        <p>{{item.btnr_4}}</p>
                        <p>{{item.btnr_5}}</p>
                        <p class="bt">{{item.bt5}}</p>
                        <p class="bt">{{item.bt6}}</p>
                        <p class="fwjs">{{item.bt7}}</p>
                        <p class="bt">{{item.bt8}}</p>
                        <p class="bt">{{item.bt9}}</p>
                        <p>{{item.btnr_6}}</p>
                        <p>{{item.btnr_7}}</p>
                        <p>{{item.btnr_8}}</p>
                        <p class="bt">{{item.bt10}}</p>
                        <p>{{item.btnr_9}}</p>
                    </div>
                    <div class="nr" v-for="(item,i) in tpContent" :key="i" v-if="active === 3">
                        <h2>{{item.gsName}}</h2>
                        <p class="bt">{{item.bt1}}</p>
                        <p>{{item.btnr_1}}</p>
                        <p class="bt">{{item.bt2}}</p>
                        <p>{{item.btnr_2}}</p>
                        <p class="bt">{{item.bt3}}</p>
                        <p>{{item.btnr_3}}</p>
                        <p class="bt">{{item.bt4}}</p>
                        <p>{{item.btnr_4}}</p>
                        <p class="bt">{{item.bt5}}</p>
                        <p>{{item.btnr_5}}</p>
                        <p class="bt">{{item.bt6}}</p>
                        <p>{{item.btnr_6}}</p>
                        <p class="bt">{{item.bt7}}</p>
                        <p>{{item.btnr_7}}</p>
                    </div>
                    <div class="nr" v-for="(item,i) in asContent" :key="i" v-if="active === 4">
                        <h2>{{item.gsName}}</h2>
                        <p class="fwjs">{{item.bt}}</p>
                        <p class="bt">{{item.bt1}}</p>
                        <p>{{item.btnr_1}}</p>
                        <p>{{item.btnr_2}}</p>
                        <p class="bt">{{item.bt2}}</p>
                        <p>{{item.btnr_3}}</p>
                        <p class="bt">{{item.bt3}}</p>
                        <p>{{item.btnr_4}}</p>
                        <p class="bt">{{item.bt4}}</p>
                        <p class="bt">{{item.bt5}}</p>
                        <p class="bt">{{item.bt6}}</p>
                        <p class="fwjs">{{item.bt7}}</p>
                        <p class="bt">{{item.bt8}}</p>
                        <p>{{item.btnr_5}}</p>
                        <p class="bt">{{item.bt9}}</p>
                        <p>{{item.btnr_55}}</p>
                        <p>{{item.btnr_6}}</p>
                        <p>{{item.btnr_7}}</p>
                        <p>{{item.btnr_8}}</p>
                        <p class="bt">{{item.bt100}}</p>
                        <p>{{item.btnr_9}}</p>
                        <p>{{item.btnr_10}}</p>
                        <p>{{item.btnr_11}}</p>
                        <p class="bt">{{item.bt10}}</p>
                        <p> {{item.btnr_12}} </p>
                        <p class="fwjs">{{item.bt11}}</p>
                        <p><img src="../../static/img/as.png" alt=""></p>
                        <p class="fwjs">{{item.bt12}}</p>
                        <p><img src="../../static/img/as_1.png" alt=""></p>
                    </div>
                    <div class="nr" v-for="(item,i) in dhContent" :key="i" v-if="active === 5">
                        <h2>{{item.gsName}}</h2>
                        <p class="bt">{{item.bt1}}</p>
                        <p>{{item.btnr_1}}</p>
                        <p>{{item.btnr_2}}</p>
                        <p class="bt">{{item.bt2}}</p>
                        <p class="bt">{{item.bt3}}</p>
                        <p>{{item.btnr_3}}</p>
                        <p class="bt">{{item.bt4}}</p>
                        <p>{{item.btnr_4}}</p>
                        <p class="bt">{{item.bt5}}</p>
                        <p>{{item.btnr_5}}</p>
                        <p class="bt">{{item.bt6}}</p>
                        <p class="bt">{{item.bt7}}</p>
                        <p>{{item.btnr_6}}</p>
                        <p>{{item.btnr_7}}</p>
                        <p>{{item.btnr_8}}</p>
                        <p>{{item.btnr_9}}</p>
                        <p>{{item.btnr_10}}</p>
                        <p>{{item.btnr_11}}</p>
                        <p>{{item.btnr_12}}</p>
                        <p>{{item.btnr_13}}</p>
                        <p>{{item.btnr_14}}</p>
                        <p>{{item.btnr_15}}</p>
                    </div>
                    <div class="nr" v-for="(item,i) in zjContent" :key="i" v-if="active === 6">
                        <h2>{{item.gsName}}</h2>
                        <p class="bt">{{item.bt1}}</p>
                        <p>{{item.btnr_1}}</p>
                        <p>{{item.btnr_2}}</p>
                        <p class="bt">{{item.bt2}}</p>
                        <p class="bt">{{item.bt3}}</p>
                        <p class="bt">{{item.bt4}}</p>
                        <p class="bt">{{item.bt5}}
                        <p>{{item.btnr_3}}</p>
                        <p>{{item.btnr_4}}</p>
                        <p>{{item.btnr_5}}</p>
                        <p>{{item.btnr_6}}</p>
                        <p>{{item.btnr_7}}</p>
                        <p>{{item.btnr_8}}</p>
                        <p>{{item.btnr_9}}</p>
                        <p>{{item.btnr_10}}</p>
                        <p class="bt">{{item.bt6}}</p>
                        <p>{{item.btnr_11}}</p>
                        <p class="bt">{{item.bt7}}</p>
                        <p class="bt">{{item.bt8}}</p>
                        <p class="bt">{{item.bt9}}</p>
                    </div>
                    <div class="nr" v-for="(item,i) in lbContent" :key="i" v-if="active === 7">
                        <h2>{{item.gsName}}</h2>
                        <p class="bt">{{item.bt1}}</p>
                        <p class="bt">{{item.bt2}}</p>
                        <p class="bt">{{item.bt3}}</p>
                        <p class="bt">{{item.bt4}}</p>
                        <p class="bt">{{item.bt5}} </p>
                        <p>{{item.btnr_1}}</p>
                        <p>{{item.btnr_2}}</p>
                        <p>{{item.btnr_3}}
                        <p class="bt">{{item.bt6}}</p>
                        <p class="bt">{{item.bt7}}</p>
                        <p class="bt">{{item.bt8}}</p>
                        <p class="bt">{{item.bt9}} </p>
                        <p>{{item.btnr_4}}</p>
                        <p>{{item.btnr_5}}</p>
                        <p>{{item.btnr_6}}
                        <p>{{item.btnr_7}}</p>
                        <p>{{item.btnr_8}}</p>
                    </div>
                    <div class="nr" v-for="(item,i) in paContent" :key="i" v-if="active === 8">
                        <h2>{{item.gsName}}</h2>
                        <p class="fwjs">{{item.bt}}</p>
                        <p class="bt">{{item.bt1}}</p>
                        <p>{{item.btnr_1}}</p>
                        <p>{{item.btnr_2}}</p>
                        <p>{{item.btnr_3}}
                        <p class="bt">{{item.bt2}}</p>
                        <p>{{item.btnr_4}}</p>
                        <p class="bt">{{item.bt3}}</p>
                        <p>{{item.btnr_5}}</p>
                        <p class="bt">{{item.bt4}}</p>
                        <p class="bt">{{item.bt5}} </p>
                        <p>{{item.btnr_7}}</p>
                        <p>{{item.btnr_8}}</p>
                        <p class="bt">{{item.bt6}}</p>
                        <p class="bt">{{item.bt7}}</p>
                        <p class="bt">{{item.bt8}}</p>
                        <p class="bt">{{item.bt9}} </p>
                        <p>{{item.btnr_6}}</p>
                    </div>
                    <div class="nr" v-for="(item,i) in hxContent" :key="i" v-if="active === 9">
                        <h2>{{item.gsName}}</h2>
                        <p class="fwjs">{{item.bt}}</p>
                        <p class="bt">{{item.bt1}}</p>
                        <p>{{item.btnr_1}}</p>
                        <p>{{item.btnr_2}}</p>
                        <p class="bt">{{item.bt2}}</p>
                        <p>{{item.btnr_3}}</p>
                        <p class="bt">{{item.bt3}}</p>
                        <p>{{item.btnr_5}}</p>
                        <p class="bt">{{item.bt4}}</p>
                        <p>{{item.btnr_6}}</p>
                        <p class="bt">{{item.bt5}} </p>
                        <p>{{item.btnr_7}}</p>
                        <p>{{item.btnr_8}}</p>
                        <p class="bt">{{item.bt6}}</p>
                        <p>{{item.btnr_9}}</p>
                        <p class="bt">{{item.bt7}}</p>
                        <p>{{item.btnr_10}}</p>
                    </div>
                    <div class="nr" v-for="(item,i) in ddContent" :key="i" v-if="active === 10">
                        <h2>{{item.gsName}}</h2>
                        <p class="fwjs">{{item.bt}}</p>
                        <p class="bt">{{item.bt1}}</p>
                        <p>{{item.btnr_1}}</p>
                        <p class="bt">{{item.bt2}}</p>
                        <p>{{item.btnr_3}}</p>
                        <p class="bt">{{item.bt3}}</p>
                        <p>{{item.btnr_5}}</p>
                        <p class="bt">{{item.bt4}}</p>
                        <p>{{item.btnr_6}}</p>
                        <p class="bt">{{item.bt5}} </p>
                        <p>{{item.btnr_7}}</p>
                        <p>{{item.btnr_8}}</p>
                        <p class="bt">{{item.bt6}}</p>
                        <p>{{item.btnr_9}}</p>
                        <p class="bt">{{item.bt7}}</p>
                        <p>{{item.btnr_10}}</p>
                    </div>
                    <div class="nr" v-for="(item,i) in zaContent" :key="i" v-if="active === 11">
                        <h2>{{item.gsName}}</h2>
                        <p class="bt">{{item.bt1}}</p>
                        <p>{{item.btnr_1}}</p>
                        <p>{{item.btnr_2}}</p>
                        <p class="bt">{{item.bt2}}</p>
                        <p>{{item.btnr_3}}</p>
                        <p class="bt">{{item.bt3}}</p>
                        <p>{{item.btnr_5}}</p>
                        <p class="bt">{{item.bt4}}</p>
                        <p>{{item.btnr_6}}</p>
                        <p class="bt">{{item.bt5}} </p>
                        <p>{{item.btnr_7}}</p>
                        <p>{{item.btnr_8}}</p>
                        <p>{{item.btnr_9}}</p>
                        <p>{{item.btnr_10}}</p>
                        <p class="bt">{{item.bt6}}</p>
                        <p>{{item.btnr_11}}</p>
                        <p class="bt">{{item.bt7}}</p>
                        <p>{{item.btnr_12}}</p>
                        <p>{{item.btnr_13}}</p>
                    </div>
                    <div class="nr" v-for="(item,i) in haContent" :key="i" v-if="active === 12">
                        <h2>{{item.gsName}}</h2>
                        <p class="fwjs">{{item.bt}}</p>
                        <p class="bt">{{item.bt1}}</p>
                        <p>{{item.btnr_1}}</p>
                        <p>{{item.btnr_2}}</p>
                        <p>{{item.btnr_3}}
                        <p class="bt">{{item.bt2}}</p>
                        <p>{{item.btnr_4}}</p>
                        <p class="bt">{{item.bt3}}</p>
                        <p>{{item.btnr_5}}</p>
                        <p class="bt">{{item.bt4}}</p>
                        <p>{{item.btnr_6}}</p>
                        <p class="bt">{{item.bt5}} </p>
                        <p>{{item.btnr_7}}</p>
                        <p>{{item.btnr_8}}</p>
                        <p class="bt">{{item.bt6}}</p>
                        <p>{{item.btnr_9}}</p>
                        <p class="bt">{{item.bt7}}</p>
                        <p>{{item.btnr_10}}</p>
                        <p>{{item.btnr_11}}</p>
                        <p>{{item.btnr_12}}</p>
                        <p>{{item.btnr_13}}</p>
                        <p> {{item.btnr_14}}</p>
                        <p>{{item.btnr_15}}</p>
                        <p>{{item.btnr_16}}</p>
                    </div>
                    <div class="nr" v-for="(item,i) in taContent" :key="i" v-if="active === 13">
                        <h2>{{item.gsName}}</h2>
                        <p class="fwjs">{{item.bt}}</p>
                        <p class="bt">{{item.bt1}}</p>
                        <p class="bt">{{item.bt2}}</p>
                        <p class="bt">{{item.bt3}}</p>
                        <p class="bt">{{item.bt4}}</p>
                        <p class="bt">{{item.bt5}} </p>
                        <p>{{item.btnr_1}}</p>
                        <p>{{item.btnr_2}}</p>
                        <p class="bt">{{item.bt6}}</p>
                        <p class="bt">{{item.bt7}}</p>
                    </div>
                    <div class="nr" v-for="(item,i) in bnContent" :key="i" v-if="active === 14">
                        <h2>{{item.gsName}}</h2>
                        <p class="fwjs">{{item.bt}}</p>
                        <p class="bt">{{item.bt1}}</p>
                        <p>{{item.btnr_1}}</p>
                        <p>{{item.btnr_2}}</p>
                        <p>{{item.btnr_3}}</p>
                        <p>{{item.btnr_4}}</p>
                        <p class="bt">{{item.bt2}}</p>
                        <p>{{item.btnr_5}}</p>
                        <p class="bt">{{item.bt3}}</p>
                        <p>{{item.btnr_6}}</p>
                        <p class="bt">{{item.bt4}}</p>
                        <p>{{item.btnr_7}}</p>
                        <p class="bt">{{item.bt5}} </p>
                        <p>{{item.btnr_8}}</p>
                        <p>{{item.btnr_9}}</p>
                        <p class="bt">{{item.bt6}}</p>
                        <p>{{item.btnr_10}}</p>
                        <p class="bt">{{item.bt7}}</p>
                        <p>{{item.btnr_11}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'xxpl',
  data () {
    return {
      active: 0,
      nav: false,
      gsList: [
        {
          name: '北京飞猪科技'
        },
        {
          name: '中国人保财险'
        },
        {
          name: '中华保险'
        },
        {
          name: '中国太平'
        },
        {
          name: '安盛天平'
        },
        {
          name: '鼎和保险'
        },
        {
          name: '紫金保险'
        },
        {
          name: '利宝保险'
        },
        {
          name: '平安产险'
        },
        {
          name: '华夏人寿'
        },
        {
          name: '大地财产保险'
        },
        {
          name: '众安保险'
        },
        {
          name: '华安保险'
        },
        {
          name: '天安财产保险'
        },
        {
          name: '百年人寿'
        }
      ],
      fzContent: [
        {
          id: '0',
          gsName: '北京飞猪科技有限公司',
          bt: '互联网保险业务规范经营承诺书',
          bt1: '为有效保护消费者权益，共同维护互联网保险市场健康可持续发展，本公司承诺如下：',
          btnr_1: '一、我们将严格遵守相关法律和规定，秉持最大诚信原则，规范从事互联网保险经营活动。',
          btnr_2: '二、本公司以及第三方合作平台的网站、APP、微信号等互联网工具，均达到监管制度要求和技术要求，不存在违反规定和重大缺陷、隐患情形。',
          btnr_3: '三、我们与第三方网络平台合作建立了完善的合作制度和风险管控体系，能有效抑制销售误导、恶意欺诈等行为，可以为消费者营造安全放心的交易环境。',
          btnr_4: ' 四、互联网保险业务的销售、承保、理赔、退保、投诉处理及客户服务等保险经营行为，均由本公司管理和负责，不具有保险业务资格的第三方网络平台仅提供网络技术支持辅助服务。',
          btnr_5: '本公司保证所提供材料真实、完整，自觉接受监管部门和行业组织的监督管理。本公司承诺对互联网保险业务经营行为承担完全法律责任。',
          bt2: ' 互联网业务(自营)基本情况',
          bt3: ' 自营网络平台（网站）产品信息'
        }
      ],
      rmContent: [
        {
          id: '1',
          gsName: '中国人民财产保险股份有限公司',
          bt: '公司及服务介绍',
          bt1: ' (一) 公司介绍',
          btnr_1: '中国人民财产保险股份有限公司（PICC P&C，简称“中国人保财险”）的前身是1949年10月20日成立的中国人民保险公司，是“世界500强”中国人民保险集团股份有限公司（PICC）的核心成员和标志性主业。2003年，中国人保财险在香港联交所主板挂牌上市（股票代码2328）。2016年，公司实现发展新跨越，保费收入突破3000亿元。',
          btnr_2: '中国人保财险始终坚持党的领导，始终坚决服从并贯彻落实党的大政方针和国家各项决策部署，牢记“人民保险 服务人民”的历史使命，坚持以市场为导向、以客户为中心，积极履行政治、经济和社会责任，做全面建设小康社会的推动者，做国家治理和社会管理的参与者，为经济发展、社会稳定、国家强盛、人民幸福提供了强大的保险保障。同时，在服务经济社会发展大局、服务民生和广大客户的实践中，中国人保财险在车辆保险、三农保险、巨灾保险、大病保险、责任保险、普惠金融和扶贫支农等主营业务方面不断取得突破，承保领域不断拓宽，涉及社会生产和人民生活的各个领域，在国内财险市场上形成了独特的、具有鲜明特色的公司核心竞争优势。',
          bt2: ' （二）公司官网（投保咨询、保单查询及客户投诉）',
          btnr_3: 'http://www.epicc.com.cn/',
          bt3: ' （三）机构网点信息：见如下网页',
          btnr_4: 'http://www.epicc.com.cn/renbao/jigouwangdian/',
          bt4: ' （四）本合同保费为一次性支付，合同采用纸质保单的形式承保。保单和保险费发票在您投保后的2个工作日送达您手中。',
          bt5: ' （五）如发现自身权益受到侵犯，请您保留相关证据并向本公司投诉，投诉电话：95518。',
          bt6: ' （六）退保及理赔方式：线下退保，服务电话：95518，赔款支付方式为转账付款。',
          bt7: ' 产品销售信息',
          bt8: ' 如实告知义务：',
          btnr_5: '1.提示投保人如实、准确提供如下信息，并对投保人告知的信息进行核对。',
          btnr_6: '2.投保人和被保险人的姓名、身份证、联系电话等人员信息。',
          btnr_7: '3.被保险车辆种类、型号、牌照号码、使用性质等车辆信息及投保的险别信息。',
          btnr_8: '4.协助投保人通过填写投保单并以签字确认的形式履行书面告知义务，通过网络渠道承保的，应提示投保人通过点击相关网页网络链接，确认已履行如实告知义务。',
          bt9: '违反义务的后果：',
          btnr_9: '1.投保人故意或因重大过失未履行如实告知义务，足以影响保险人决定是否同意承保或提高费率的，保险人有权解除合同。',
          btnr_10: '2.投保人故意不履行如实告知义务的，保险人对于合同解除前发生的保险事故，不承担赔偿保险金的责任，并且不退还保险费。',
          btnr_11: '3.投保人因重大过失未履行如实告知义务，对保险事故的发生有严重影响的，保险人对于合同解除前发生的保险事故，不承担赔偿保险金的责任，但退还保险费。',
          bt10: '信息安全：',
          btnr_12: '我们严格遵守现行的关于个人信息、数据及隐私保护的法律法规，采取充分的技术手段和制度管理，保护您提供给我们的个人信息、数据和隐私不受到非法的泄露或披露给未获授权的第三方。',
          bt11: '投保流程',
          btnr_13: '1.填写资料   2.精准报价   3.确认支付   4.查收保单',
          bt12: '理赔流程',
          btnr_14: ' 1.拨打95518报案',
          btnr_15: '  2.配合警方和安盛天平保险公司进行事故处理及损失计算',
          btnr_16: ' 3.事故车辆维修和受伤人员治疗',
          btnr_17: '  4.提交索赔资料进行审核',
          btnr_18: '  5.领取索赔款'
        }
      ],
      zhContent: [
        {
          id: '2',
          gsName: '中华联合保险控股股份有限公司',
          bt: '合作公司及服务介绍',
          bt1: '(一) 公司介绍',
          btnr_1: '中华保险，全称为中华联合保险控股股份有限公司，全国唯一一家以“中华”冠名的保险公司，始创于1986年7月15日，是我国成立的第二家具有独立法人资格的国有控股保险公司。公司旗下设有中华联合财产保险股份有限公司、中华联合人寿保险股份有限公司、万联电子商务股份有限公司，正在申请筹建的资产管理公司和农险公司。',
          bt2: '(二)公司官网（投保咨询、保单查询及客户投诉）',
          btnr_2: 'http:// www.cic.cn',
          bt3: '（三）机构网点信息：见如下网页',
          btnr_3: ' http://property.cic.cn/publish/portal0/tab120/',
          bt4: '（四）保单及凭证的配送说明：',
          btnr_4: ' 电子保单：“保险单证、保险费发票等默认不予配送，如您需要纸质保单可凭借被保险人身份证原件前往我公司当地营业厅进行索取。”',
          btnr_5: '纸质保单：“保险单证、保险费发票等由合作的快递公司进行配送或可上营业厅取单，配送不另收费用。”',
          bt5: ' （五）投保、退保及理赔方式：在线投保、线下退保；理赔为转账付款。全国24小时服务电话：95585。',
          bt6: ' （六）中华联合财产保险股份有限公司已采取相应的技术、网络等风控措施，确保客户的个人信息、投保交易信息和交易安全。',
          bt7: ' 产品销售信息',
          bt8: '（一）合作公司为：中华联合财产保险股份有限公司',
          bt9: '（二）产品信息',
          btnr_6: '合作产品信息为：机动车辆保险',
          btnr_7: '保险产品条款：中国保险行业协会机动车综合商业保险示范条款',
          btnr_8: '审批/备案编号：H2015102',
          bt10: '（三）其他',
          btnr_9: '投保人需遵守如实告知义务，如违反如实告知义务，则按《保险法》相关规定处理。'
        }
      ],
      tpContent: [
        {
          id: '3',
          gsName: '中国太平保险集团有限责任公司',
          bt: '',
          bt1: '一、公司名称：',
          btnr_1: '中国太平保险集团有限责任公司',
          bt2: '二、注册资本：',
          btnr_2: '人民币贰佰伍拾贰亿陆仟零柒拾伍万元整',
          bt3: '三、法定代表人',
          btnr_3: ' 王滨',
          bt4: '四、经营范围',
          btnr_4: ' 本公司及下属子公司的业务范围涵盖寿险、财险、养老保险、再保险、再保险经纪及保险代理、互联网保险、资产管理、证券经纪、金融租赁、不动产投资、养老产业投资等。',
          bt5: ' 五、基本财务数据',
          btnr_5: ' 2016年，中国太平实现总保费1,275亿元人民币，截至2016年底，集团总资产超过4,500亿元人民币。',
          bt6: ' 六、客服热线',
          btnr_6: '95589',
          bt7: '7、公司网址',
          btnr_7: 'http://www.cntaiping.com/'
        }
      ],
      asContent: [
        {
          id: '4',
          gsName: '安盛天平财产保险股份有限公司',
          bt: '公司及服务介绍',
          bt1: ' （一）公司介绍',
          btnr_1: '安盛天平由原中国第一家专业车险公司天平汽车保险与国际领先保险集团AXA安盛集团在华全资财产险子公司合并而设立。依托AXA安盛集团雄厚的财务实力，卓越的品牌价值和领先的专业能力，并融合了天平保险丰富的本土经验资源和服务网络，致力于为广大客户提供及时、便捷、值得信赖的保险服务。',
          btnr_2: '公司总部设在上海浦东陆家嘴金融区，注册资本8.46亿元，主要经营机动车交通事故责任强制保险、机动车商业保险和企业财产险、家财险、货运险、责任险、短期意外险、健康险等业务。',
          bt2: '（二）公司官网（投保咨询、保单查询及客户投诉）',
          btnr_3: 'http://www.axatp.com/',
          bt3: ' （三）机构网点信息：见如下网页',
          btnr_4: 'http://www.axatp.com/about_us/branch.html',
          bt4: ' （四）本合同保费为一次性支付，合同采用纸质保单的形式承保。保单和保险费发票在您投保后的2个工作日送达您手中。',
          bt5: ' （五）如发现自身权益受到侵犯，请您保留相关证据并向本公司投诉，投诉电话：95550。',
          bt6: ' （六）退保及理赔方式：线下退保，服务电话：95550，赔款支付方式为转账付款。',
          bt7: ' 产品销售信息',
          bt8: ' 合作产品',
          btnr_5: '【安盛天平车险】商业险 交强险 优惠套餐 汽车保险，报备文件编号为保监产险【2009】990号、保监许可【2015】458号，保监许可【2015】1304号。',
          bt9: ' 如实告知义务：',
          btnr_55: '1.提示投保人如实、准确提供如下信息，并对投保人告知的信息进行核对。',
          btnr_6: '2.投保人和被保险人的姓名、身份证、联系电话等人员信息。',
          btnr_7: '3.被保险车辆种类、型号、牌照号码、使用性质等车辆信息及投保的险别信息。',
          btnr_8: '4.协助投保人通过填写投保单并以签字确认的形式履行书面告知义务，通过网络渠道承保的，应提示投保人通过点击相关网页网络链接，确认已履行如实告知义务。',
          bt100: '违反义务的后果：',
          btnr_9: '1.投保人故意或因重大过失未履行如实告知义务，足以影响保险人决定是否同意承保或提高费率的，保险人有权解除合同。',
          btnr_10: '2.投保人故意不履行如实告知义务的，保险人对于合同解除前发生的保险事故，不承担赔偿保险金的责任，并且不退还保险费。',
          btnr_11: '3.投保人因重大过失未履行如实告知义务，对保险事故的发生有严重影响的，保险人对于合同解除前发生的保险事故，不承担赔偿保险金的责任，但退还保险费。',
          bt10: '信息安全：',
          btnr_12: '我们严格遵守现行的关于个人信息、数据及隐私保护的法律法规，采取充分的技术手段和制度管理，保护您提供给我们的个人信息、数据和隐私不受到非法的泄露或披露给未获授权的第三方。',
          bt11: '投保流程',
          bt12: '理赔流程'
        }
      ],
      dhContent: [
        {
          id: '5',
          gsName: '鼎和财产保险股份有限公司',
          bt: '',
          bt1: '一、 法定名称及缩写',
          btnr_1: '鼎和财产保险股份有限公司DINGHE PROPERTY INSURANCE CO., Ltd.',
          btnr_2: '鼎和保险 DHIC',
          bt2: '二、 注册资本：30.18亿元',
          bt3: '三、 注 册 地：深圳',
          btnr_3: ' 公司住所：深圳市福田区福华三路100号鼎和大厦36-40层',
          bt4: '四、 成立时间：2008年5月22日',
          bt5: ' 五、 经营范围和区域：',
          btnr_4: '  经营范围：在全国范围内经营财产损失保险；责任保险；信用保险和保证保险；短期健康保险和意外伤害保险；上述业务的再保险业务；国家法律法规允许的保险资金运用业务；经中国保监会批准的其他业务。',
          btnr_5: ' 经营区域：广东、广西、云南、贵州、海南、深圳、四川、上海、湖北、河南、江西、陕西、山东、河北。',
          bt6: '  六、 法定代表人：王晓锦',
          bt7: '七、 客服电话和投诉电话：95393',
          btnr_6: '投诉渠道：鼎和财险全国统一客户投诉电话：95393-7',
          btnr_7: '官网投诉平台：鼎和保险官网首页www.edhic.com>在线客服>其他问题>我要投诉',
          btnr_8: '信函及接待地址、传真号码、投诉受理电子邮箱等投诉渠道，请关注各省级分公司及分支机构公布信息。',
          btnr_9: '投诉处理程序（一般投诉）：',
          btnr_10: '1.登记投诉',
          btnr_11: '2.受理投诉',
          btnr_12: '3.登记投诉',
          btnr_13: '4.受理投诉',
          btnr_14: '5.登记投诉',
          btnr_15: '6.受理投诉'
        }
      ],
      zjContent: [
        {
          id: '6',
          gsName: '紫金财产保险股份有限公司',
          bt: '',
          bt1: '一、法定名称及缩写',
          btnr_1: '中文名称：紫金财产保险股份有限公司',
          btnr_2: '缩写：紫金保险',
          bt2: '二、注册资本：25亿元人民币',
          bt3: '三、注册地：江苏省南京市建邺区兴隆大街188号奥体邻里中心综合楼1-4层',
          bt4: '四、成立时间：2009年5月8日',
          bt5: '五、经营范围和经营区域',
          btnr_3: ' 经营范围：按照《中华人民共和国保险法》、《保险公司管理规定》及中国保险监督管理委员会有关规范性文件的规定， 公司经营下列全部或部分保险业务：',
          btnr_4: '  (一)财产损失保险；',
          btnr_5: ' (二)责任保险；',
          btnr_6: ' (三)信用保险和保证保险；',
          btnr_7: '(四)短期健康保险和意外伤害保险；',
          btnr_8: '(五)上述保险业务的再保险业务；',
          btnr_9: ' (六)国家法律和法规允许的保险资金运用业务；',
          btnr_10: '(七)经中国保险监督管理委员会批准的其他业务。',
          bt6: '经营区域： +',
          btnr_11: '  江苏、北京、浙江、宁波、上海、河北、广东、山东、四川、安徽、河南、湖北、福建、湖南、青岛、内蒙古、天津、辽宁、广西、山西、深圳、厦门、云南。',
          bt7: '六、法定代表人：李明耀',
          bt8: '七、公司官网：http://www.zking.com/',
          bt9: ' 八、客服电话和投诉电话 95312'
        }
      ],
      lbContent: [
        {
          id: '7',
          gsName: '利宝保险有限公司',
          bt: '',
          bt1: '1.法定中文名称：利宝保险有限公司 缩写：利宝保险',
          bt2: '2.注册资本：壹拾伍亿零壹佰叁拾叁万叁仟元人民币',
          bt3: '3.注册地：重庆市渝中区中山三路131号庆隆希尔顿商务中心35层',
          bt4: '4.成立时间：2003年12月，美国利宝互助保险公司在中国重庆设立分公司，成为重庆地区唯一的一家外资财产保险公司。2007年7月，经中国保险监督管理委员会的批准，美国利宝互助保险公司在中国的分公司正式改建为在中国的全资子公司-利宝保险有限公司。2007年9月改建工作全部完成。',
          bt5: '5.经营范围：除法定保险业务以外的下列保险业务',
          btnr_1: '（1）财产损失保险、责任保险（包括机动车交通事故责任强制保险）、信用保险、保证保险等财产保险业务',
          btnr_2: '（2）短期健康保险、意外伤害保险',
          btnr_3: '（3）上述业务的再保险业务',
          bt6: '经营区域：重庆、北京、浙江、广东、山东、四川',
          bt7: '6.法定代表人：Daniel Martin Bridger',
          bt8: '7.客服电话和投诉电话：400 888 2008',
          bt9: '8.机动车辆保险',
          btnr_4: '（1）机动车交通事故责任强制保险条款',
          btnr_5: '（2）利宝保险有限公司-机动车综合商业保险示范条款',
          btnr_6: '（3）利宝保险有限公司-摩托车、拖拉机综合商业保险示范条款',
          btnr_7: '（6）利宝保险有限公司-特种车综合商业保险示范条款',
          btnr_8: '（5）利宝保险有限公司-机动车单程提车保险示范条款'
        }
      ],
      paContent: [
        {
          id: '8',
          gsName: '中国平安财产保险股份有限公司',
          bt: '公司概况',
          bt1: '（一）法定名称：',
          btnr_1: '[中文全称]：中国平安财产保险股份有限公司；',
          btnr_2: '[中文简称]：平安产险；',
          btnr_3: '[英文全称]：Ping An Property & Casualty Insurance Company of China，Ltd.',
          bt2: '（二）注册资本：',
          btnr_4: '人民币210亿元，实收资本人民币210亿元。',
          bt3: '（三）注册地：',
          btnr_5: '深圳市福田区益田路5033号平安金融中心12、13、38、39、40层。',
          bt4: '（四）成立时间：',
          btnr_6: '公司以发起方式设立，于2002年12月24日在国家工商行政管理总局登记注册。',
          bt5: '（五）经营范围和经营区域：',
          btnr_7: '[经营范围]：承保人民币和外币的各种财产保险业务，包括财产损失保险、责任保险、信用保险等保险业务；办理上述业务的再保险业务；办理各种法定财产保险业务；办理短期健康保险和意外伤害保险业务；代理国内外保险机构检验、理赔、追偿及其委托的其他有关事宜；依照有关法律法规从事资金运用业务；经中国保监会批准的其他业务。一般经营项目：无。',
          btnr_8: '[经营区域]：中华人民共和国境内（港、澳、台地区除外），包括北京市、天津市、河北省、山西省、内蒙古自治区、辽宁省、吉林省、黑龙江省、上海市、江苏省、浙江省、安徽省、福建省、江西省、山东省、河南省、湖北省、湖南省、广东省、广西壮族自治区、海南省、重庆市、四川省、贵州省、云南省、西藏自治区、陕西省、甘肃省、青海省、宁夏回族自治区、新疆维吾尔自治区。',
          bt6: '（六）法定代表人：孙建平',
          bt7: '（七）客服电话和投诉电话：',
          btnr_9: '全国统一客户服务及投诉热线：95511。'
        }
      ],
      hxContent: [
        {
          id: '9',
          gsName: '华夏人寿保险股份有限公司',
          bt: '公 司 简 介',
          bt1: '（一）法定名称及缩写',
          btnr_1: '[中文全称]：华夏人寿保险股份有限公司',
          btnr_2: '[名称缩写]：华夏人寿保险公司',
          bt2: '（二）注册资本金',
          btnr_3: '公司注册资本金为153亿元人民币。',
          bt3: '（三）注册地',
          btnr_5: '天津市滨海新区中心商务区水线路2号增1号于家堡金融区服务中心101-30',
          bt4: '（四）成立时间',
          btnr_6: '公司以发起方式设立，并于2006年12月30日成立',
          bt5: '（五）经营范围和经营区域',
          btnr_7: '[经营范围]：人寿保险、健康保险、意外伤害保险等各类人身保险业务；上述业务的再保险业务；国家法律、法规允许的保险资金运用业务；经中国保监会批准的其他业务。',
          btnr_8: '[经营区域]：陕西、北京、河南、江苏（含苏州、无锡）、山东（含青岛）、安徽、内蒙古、湖南、四川、云南、河北、广东（含深圳、东莞）、浙江（含宁波）、上海、天津、江西、海南、黑龙江。',
          bt6: '（六）法定代表人',
          btnr_9: '[法定代表人]：李飞',
          bt7: '（七）客服电话及投诉电话',
          btnr_10: '[全国统一客服电话及投诉电话为]：95300'
        }
      ],
      ddContent: [
        {
          id: '10',
          gsName: '中国大地财产保险股份有限公司',
          bt: '公 司 概况',
          bt1: '一、公司名称',
          btnr_1: '中国大地财产保险股份有限公司',
          btnr_2: '',
          bt2: '二、注册资本',
          btnr_3: '人民币15,115,918,986元',
          bt3: '三、注册地',
          btnr_5: '上海市浦东新区银城中路501号上海中心大厦26层、27层、28层',
          bt4: '四、成立时间',
          btnr_6: '2003年10月15日',
          bt5: '五、经营范围和经营区域',
          btnr_7: '经营范围：企业财产损失保险、家庭财产损失保险、建筑工程保险、安装工程保险、货物运输保险、机动车辆保险、船舶保险、飞机保险、航天保险、核电站保险、能源保险、法定责任 保险、一般责任保险、保证保险、信用保险、种植业务保险、养殖业保险、短期健康保险、意外伤害保险，上述保险业务的再保险业务；经中国保监会批准的资金运用业务。',
          btnr_8: '经营区域：北京市、天津市、河北省、山西省、内蒙古自治区、辽宁省、吉林省、黑龙江省、上海市、江苏省、浙江省、安徽省、福建省、江西省、山东省、河南省、湖北省、湖南省、 广东省、广西壮族自治区、海南省、重庆市、四川省、贵州省、云南省、陕西省、甘肃省、青海省、宁夏回族自治区和新疆维吾尔自治区。',
          bt6: '六、法定代表人',
          btnr_9: '陈勇',
          bt7: '七、客服电话、投诉电话和投诉处理程序',
          btnr_10: '[全国统一客服电话及投诉电话为]：95590'
        }
      ],
      zaContent: [
        {
          id: '11',
          gsName: '众安在线财产保险股份有限公司',
          bt: '',
          bt1: '1.法定名称及缩写',
          btnr_1: '中文名称：众安在线财产保险股份有限公司',
          btnr_2: '中文简称：众安保险 ',
          bt2: '2.注册资本',
          btnr_3: '注册资本人民币14.698129亿元 ',
          bt3: '3.注册地',
          btnr_5: '上海市黄浦区圆明园路169号协进大楼4-5楼',
          bt4: '4.成立时间',
          btnr_6: '二零一三年十月九日',
          bt5: '5.经营范围和经营区域',
          btnr_7: '经营范围：',
          btnr_8: '与互联网交易直接相关的企业/家庭财产保险、货运保险、责任保险、信用保证保险、短期健康/意外伤害保险；机动车保险，包括机动车交通事故责任强制保险和机动车商业保险;上述业务的再保险分出和再保险分入业务（仅限临时分保分入）；国家法律、法规允许的保险资金运用业务；保险信息服务业务;经中国保监会批准的其他业务。',
          btnr_9: '经营区域：',
          btnr_10: '在中华人民共和国境内（港、澳、台地区除外）开展与互联网交易直接相关的保险业务，不设分支机构。',
          bt6: '6.法定代表人',
          btnr_11: '欧亚平',
          bt7: '7.客服电话和投诉电话',
          btnr_12: '客服电话：1010-9955或400-999-9595',
          btnr_13: '业务建议及投诉专线：021-80399188'
        }
      ],
      haContent: [
        {
          id: '12',
          gsName: '华安财产保险股份有限公司',
          bt: '公司概况',
          bt1: '（一）公司名称',
          btnr_1: '公司名称：华安财产保险股份有限公司',
          btnr_2: '英文名称：Sinosafe General Insurance Company Limited ',
          btnr_3: '公司简称：华安保险 ',
          bt2: '（二）注册资本',
          btnr_4: '注册资本：人民币21亿元',
          bt3: '（三）公司住所和营业场所',
          btnr_5: '深圳市罗湖区深南东路5015号金丰城大厦2层A23楼',
          bt4: '（四）成立时间',
          btnr_6: '成立时间：1996年12月3日',
          bt5: '(五）经营范围和经营区域',
          btnr_7: '公司经营范围为：各类财产保险、机动车辆保险、飞机保险、船舶保险、货物运输保险、责任保险、信用保险、保证保险、农业保险、财产损失保险、短期健康保险、意外伤害保险、其他损失保险等；根据国家有关规定开办法定保险；上述业务的再保险业务；代理国内外保险公司办理检验、理赔、追偿等有关事宜；经中国保险监督管理委员会批准的资金运用业务；经中国保险监督管理委员会批准的其他业务。',
          btnr_8: '经营区域：北京、上海、深圳、广东、湖南、福建、广西、江苏、四川、浙江、大连、山东、重庆、云南、陕西、辽宁、江西、山西、天津、安徽、湖北、河南、宁波、黑龙江、河北、贵州、青岛、内蒙古、吉林、海南、甘肃。',
          bt6: '（六）法定代表人',
          btnr_9: '法定代表人：李光荣',
          bt7: '（七）客服电话、投诉渠道和投诉处理程序',
          btnr_10: '投诉受理渠道：',
          btnr_11: '全国统一客户服务电话：95556',
          btnr_12: '全国统一客户服务邮箱：95556@sinosafe.com.cn',
          btnr_13: '全国统一客服短信平台：95556',
          btnr_14: '自有多媒体客服渠道（官网及微信在线客服）',
          btnr_15: '门店',
          btnr_16: '保险消费者可以通过拨打保险消费投诉电话（95556转6键）及发送短信、邮件和通过公司自有多媒体渠道、门店等渠道提出投诉。'
        }
      ],
      taContent: [
        {
          id: '13',
          gsName: '天安财产保险股份有限公司',
          bt: '公司概况',
          bt1: '1、公司名称：天安财产保险股份有限公司',
          bt2: '2、注册资本：人民币17,763,751,770元',
          bt3: '3、公司住所和营业场所：中国（上海）自由贸易试验区浦东大道1号',
          bt4: '4、成立时间：1995年1月27日',
          bt5: '5、经营范围和经营区域',
          btnr_1: '1）经营范围：承保人民币、外币的各种财产保险、责任保险、信用保险、水险、意外伤害保险、健康保险及金融服务保险等业务；办理各种再保险业务和法定 保险业务；与国内外保险机构建立代理关系和业务往来关系，代理检验、理赔、追偿等有关事宜；办理经中国保监会批准的资金运用业务；经中国保监会批准的其他业务。',
          btnr_2: '2）经营区域：公司经营区域覆盖32个省、市、自治区。 北京、天津、河北、山西、辽宁、吉林、黑龙江、上海、江苏、浙江、安徽、福建、江西、山东、河南、湖北、湖南、广东、广西、海南、重庆、四川、贵州、云南、陕西、甘肃、新疆、深圳、大连、宁波、青岛、厦门 ',
          bt6: '6、法定代表人：郭予丰',
          bt7: '7、客服电话和投诉电话：95505'
        }
      ],
      bnContent: [
        {
          id: '14',
          gsName: '百年人寿保险股份有限公司 ',
          bt: '公司概况',
          bt1: '公司法定名称及缩写',
          btnr_1: '中文名称:百年人寿保险股份有限公司 ',
          btnr_2: '中文简称:百年人寿',
          btnr_3: '英文名称:AEON LIFE INSURANCE COMPANY,LTD.',
          btnr_4: '英文简称:AEON LIFE',
          bt2: '注册资本',
          btnr_5: '注册资本:77.948亿元人民币(柒拾柒亿玖仟肆佰捌拾万元人民币)',
          bt3: '公司住所和营业场所',
          btnr_6: '公司场所和营业场所:大连市沙河口区体坛路22号诺德大厦21、22、23层',
          bt4: '成立时间',
          btnr_7: '注册资本:2009年6月1日',
          bt5: '经营范围和经营区域',
          btnr_8: '经营范围:人寿保险、健康保险、意外伤害保险等各类人身保险业务;上述业务的 再保险业务;国家法律、法规允许的保险资金运用业务;经中国保监会 批准的其他业务。',
          btnr_9: '经营区域:大连、湖北、河北、辽宁、北京、河南、黑龙江、安徽、山东、江苏、 四川、福建、陕西、内蒙古、吉林、江西、浙江、山西、广东、重庆',
          bt6: '法定代表人',
          btnr_10: '法定代表人:何勇生',
          bt7: '公司客户服务和投诉电话',
          btnr_11: '公司客户服务和投诉电话:95542'
        }
      ]
    }
  },
  mounted () {
    if(this.isMobile()) {
          this.$router.push({ path: "/disclosure" });
        } else {
          this.$router.push({ path: "/xxpl?page=7" });
        }
    let navH = 600
    window.onscroll = _ => {
      var SH = document.body.scrollTop || document.documentElement.scrollTop
      if (SH >= (navH - 20)) {
        this.nav = true
      } else {
        this.nav = false
      }
    }
  },
  methods: {
     isMobile() {
        let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
        return flag;
    }
  },
}
</script>

<style lang="scss" scoped>
.content {
    width: 100%;
    max-width: 19.2rem;
    background-color: #024ea2;
    margin: 0 auto;
    // height: ;
    .content_pl {
        width: 12rem;
        margin: 0 auto;
        background-color: #f2f2f2;
        overflow: hidden;
        box-sizing: border-box;
        position: relative;
        padding: .60rem .15rem;
        top: -0.45rem;
        .gsList {
            position: absolute;
            top: .5rem;
            left: .2rem;
            width: 2.5rem;
            height: 5rem;
            p {
                width: 2.4rem;
                height: .39rem;
                color: #a3a3a3;
                line-height: .39rem;
                text-align: center;
                font-size: .24rem;
                box-sizing: border-box;
                cursor: pointer;
                span {
                    border-top: 3px solid #cecece;
                    width: 2.4rem;
                    display: block;
                    box-sizing: border-box;
                    padding-right: .5rem;
                    text-align: right;
                }
            }
            p:nth-last-child(1) {
                border-bottom: 3px solid #cecece;
            }
            .active {
                color: #d9081e;
                cursor: pointer;
                border-right: 5px solid #d9081e;
            }
        }
        .active_nav2 {
            position: fixed;
            top: 45%;
            left: 50%;
            margin-left: -5.8rem;
            margin-top: -3.30rem;
        }
        .gsjs {
            width: 8.80rem;
            float: right;
            box-sizing: border-box;
            font-size: .22rem;
            padding-right: .4rem;
            h2 {
                font-size: .28rem;
                color: #e20f20;
            }
            .fwjs {
                width: 3.1rem;
                height: .8rem;
                background-color: #de101d;
                border-radius: 0 .4rem .4rem 0;
                color: #ffe9e9;
                font-size: .3rem;
                text-align: center;
                line-height: .8rem;
                font-weight: 600;
                margin: .5rem 0 .25rem 0;
                text-indent: 0em;
            }
            .f500 {
                width: 4.3rem;
                text-align: left;
                padding: 0 .3rem;
            }
            table {
                font-size: .2rem;
                color: #606060;
                td {
                    padding: .1rem;
                    text-align: center;
                }
            }
            .bt {
                line-height: .35rem;
                font-size: .24rem;
                font-weight: 700;
                color: #2f2f2f;
                text-indent: 0em;
            }
            p {
                margin: .1rem 0;
                line-height: .34rem;
                color: #595959;
                text-indent: 2em;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/Xxpl.vue